import React from "react";
import { Box, Grid, Skeleton, Container } from "@mui/material";

const ProgramsSkeleton = () => {
  return (
    <Box
      sx={{
        backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
        color: "#FFFFFF",
        paddingY: "100px",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="lg">
        {/* Page Header Skeleton */}
        <Box sx={{ textAlign: "center", marginBottom: "40px" }}>
          <Skeleton
            variant="text"
            sx={{
              backgroundColor: "#A9C9EA",
              height: { xs: "40px", md: "60px" },
              width: { xs: "60%", md: "40%" },
              margin: "0 auto",
            }}
          />
          <Skeleton
            variant="text"
            sx={{
              backgroundColor: "#D1D5DB",
              height: "24px",
              width: { xs: "80%", md: "60%" },
              margin: "20px auto",
            }}
          />
        </Box>

        {/* Filter Buttons Skeleton */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: { xs: "wrap", md: "nowrap" },
            gap: { xs: "15px", md: "25px" },
            mb: "40px",
          }}
        >
          {[1, 2, 3, 4].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                backgroundColor: "#A9C9EA",
                height: "50px",
                width: "120px",
                borderRadius: "25px",
              }}
            />
          ))}
        </Box>

        {/* Programs Grid Skeleton */}
        <Grid container spacing={6}>
          {Array.from(new Array(6)).map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  backgroundColor: "#1A2E55",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 8px 40px rgba(0, 0, 0, 0.2)",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  height={240}
                  sx={{
                    backgroundColor: "#D1D5DB",
                    borderRadius: "12px 12px 0 0",
                  }}
                />
                <Box sx={{ padding: "20px" }}>
                  <Skeleton
                    variant="text"
                    sx={{
                      backgroundColor: "#A9C9EA",
                      height: "28px",
                      width: "80%",
                      marginBottom: "10px",
                    }}
                  />
                  <Skeleton
                    variant="text"
                    sx={{
                      backgroundColor: "#A9C9EA",
                      height: "20px",
                      width: "60%",
                      marginBottom: "20px",
                    }}
                  />
                  <Skeleton
                    variant="text"
                    sx={{
                      backgroundColor: "#D1D5DB",
                      height: "16px",
                      width: "100%",
                      marginBottom: "16px",
                    }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    width={150}
                    sx={{
                      backgroundColor: "#A9C9EA",
                      borderRadius: "20px",
                      margin: "0 auto",
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ProgramsSkeleton;
